import { DOMAIN } from "js/constants";

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function blobUrlToBlob(blobUrl) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', blobUrl, true);
    xhr.responseType = 'blob';

    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject(new Error('Failed to load blob URL'));
      }
    };

    xhr.onerror = () => reject(new Error('XHR error'));
    xhr.send();
  });
}

async function removeBackgroundBase64(imageSrc) {
  const endpoint = `/api/edition/remove-background-b64`;

  let base64Data;

  if (imageSrc.startsWith('data:')) {
    base64Data = imageSrc.split(',')[1];
  }

  else if (imageSrc.startsWith('blob:')) {
    const blob = await blobUrlToBlob(imageSrc);
    base64Data = await blobToBase64(blob);
  }

  console.log('Starting background removal for base64 image source.');

  let formData = new FormData();
  formData.append('imageData', base64Data);
  formData.append('version', 'local');

  const response = await fetch(endpoint, {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    throw new Error('Network response was not ok for base64 image source.');
  }

  const data = await response.json();
  console.log('Background removal (base64) response data:', data);
  return data;
}

async function removeBackgroundHttpUrl(imageSrc) {
  const endpoint = `/api/edition/remove-background`;

  console.log('Starting background removal for HTTP URL image source:', imageSrc);

  let formData = new FormData();
  formData.append('imageSrc', imageSrc);
  formData.append('version', 'local');

  const response = await fetch(endpoint, {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    console.log('Response not ok:', response);
    throw new Error('Network response was not ok for HTTP URL image source: ' + imageSrc);
  }

  const data = await response.json();
  console.log('Background removal (HTTP URL) response data:', data);
  return data;
}

export async function removeBackgroundFromImage(imageSrc) {

  const isDataUrl = imageSrc.startsWith('data:');
  const isBlobUrl = imageSrc.startsWith('blob:');
  const isHttpUrl = imageSrc.startsWith('http://') || imageSrc.startsWith('https://');

  console.log('Image source type:', { isDataUrl, isBlobUrl, isHttpUrl });

  if (isDataUrl || isBlobUrl) {
    return await removeBackgroundBase64(imageSrc);
  } else if (isHttpUrl) {
    return await removeBackgroundHttpUrl(imageSrc);
  } else {
    throw new Error('Unsupported image source format for background removal.');
  }
}